import { jsx as _jsx } from "react/jsx-runtime";
import { MainContentContext } from './MainContent.context';
import { MainContentStyled } from './MainContent.styled';
const MainContent = ({ children, maxWidth, ...props }) => {
    return (_jsx(MainContentContext.Provider, { value: props, children: _jsx(MainContentStyled, { ...props, maxWidth: maxWidth, children: children }) }));
};
export { MainContent };
